import {
  BrandVariants,
  createDarkTheme,
  createLightTheme,
  Theme,
} from "@fluentui/react-components";

// BNP Paribas green (#00965E) as the key color. Ramp generated with the Fluent UI
// Theme Designer; regenerate here if the brand color changes.
export const bnpBrand: BrandVariants = {
  10: "#020403",
  20: "#101F18",
  30: "#123528",
  40: "#134534",
  50: "#135640",
  60: "#12684D",
  70: "#0F7A5A",
  80: "#00965e",
  90: "#33A87D",
  100: "#57B892",
  110: "#75C6A6",
  120: "#92D4BB",
  130: "#AFE1CF",
  140: "#CCEEE4",
  150: "#E5F7F0",
  160: "#F3FBF8",
};

/** Corporate light theme. */
export const bnpLightTheme: Theme = createLightTheme(bnpBrand);

/**
 * Corporate dark theme (Axis 12: dark mode). `createDarkTheme` derives
 * foreground/background pairs from the same brand ramp used by
 * `bnpLightTheme`, inverting the neutral scale while keeping brand hues
 * consistent between modes. The BNP ramp spans a near-black stop (10) to a
 * near-white stop (160), which is what `createDarkTheme` needs to derive
 * readable contrast automatically — spot-checked via code read here, but a
 * human should still eyeball the first sideload (see PR description).
 */
export const bnpDarkTheme: Theme = createDarkTheme(bnpBrand);
